export const sage200 = {
  sage200_discrepancy_item_po_notattached: `PO reference is missing in item '{{1}}'`,
  // sage200_matching_discrepancy_item_quantity_mismatch: `Quantity in Invoice {{2}}  plus previously consumed quantity {{6}}, Quantities have been consumed in documents {{5}}. does not align with PO {{3}}, which specifies a quantity of {{4}}.`,
  sage200_matching_discrepancy_item_quantity_mismatch: `Invoice quantity {{2}}, combined with total consumed quantity {{6}} from prior documents {{5}}, does not align with {{3}}, which specifies a quantity of {{4}}.`,
  sage200_discrepancy_item_quantity_mismatch: `{{1}} has {{2}} on the invoice but {{4}} in PO {{3}}`,
  // sage200_discrepancy_item_unitprice_mismatch: `Unit price '{{2}}' in item '{{1}}' does not match with unit price '{{4}}' in PO '{{3}}'`,
  sage200_discrepancy_item_unitprice_mismatch: `{{1}} is '{{2}}' in the invoice but {{4}} in PO {{3}}`,
  sage200_discrepancy_item_unitprice_missing: "Unit price is missing in item",
  sage200_discrepancy_poitem_unitprice_missing:
    "Unit price is missing in PO item",
  sage200_discrepancy_item_quantity_missing: "Quantity is missing in item",
  sage200_discrepancy_poitem_quantity_missing: "Quantity is missing in PO item",
  adjusted_for_prior_consume: "ADJUSTED FOR PRIOR {{document}}",
  matched: "Matched",
  all: "All",
  discrepancies: "Discrepancies",
  matching_document_not_found: "Matching document not found",
  line_matching: "Line Matching",
  dicrepancies_matching: "Matches & Discrepancies",
  sage200_discrepancy_item_dn_notattached: `Delivery note reference is missing in item '{{1}}'`,
  sage200_discrepancy_dnitem_quantity_missing: `Quantity is missing in item`,
  sage200_discrepancy_dnitem_unitprice_missing: `Unit price is missing in Delivery note item`,
  "Sage200 IN<>DN": `Sage 200 Invoice <> DeliveryNote`,
  Sage200_INDN_DN_NotAttached: `Delivery Note not attached`,
  Sage200_INDN_DN_NotAttached_description: `The referenced Delivery Note is not attached or could not be found.`,

  Sage200_INDN_Quantity_NotMatch: `Quantity does not match`,
  Sage200_INDN_Quantity_NotMatch_description: `The quantity on the invoice does not match the quantity on the Delivery Note.`,

  Sage200_INDN_UnitPrice_NotMatch: `Unit price does not match`,
  Sage200_INDN_UnitPrice_NotMatch_description: `The unit price on the invoice does not match the unit price on the Delivery Note.`,
  sage200_discrepancy_item_contract_notattached: `Contract not attached`,
  sage200_incntrct_discrepancy_item_quantity_missing: `Item quantity is missing`,
  sage200_incntrct_discrepancy_contractitem_quantity_missing: `Quantity is missing in contract item`,
  sage200_incontrct_matching_discrepancy_item_quantity_mismatch: `The item quantity '{{2}}', combined with the total consumed quantity '{{6}}', does not align with contract '{{3}}', which specifies a quantity of '{{4}}'. Quantities have been consumed in documents '{{5}}'.`,
  sage200_incntrct_discrepancy_item_quantity_mismatch: `Quantity '{{2}}' in item '{{1}}' does not match with quantity '{{4}}' in contract '{{3}}'`,
  sage200_incontrct_discrepancy_item_unitprice_mismatch: `Unit price '{{2}}' in item '{{1}}' does not match with unit price '{{4}}' in contract '{{3}}'`,
  indn_account_class_required:
    "Account classification is required for this indent item.",
  Sage200_INCONTRACT_Contract_NotAttached: `Contract not attached`,
  Sage200_INCONTRACT_Quantity_NotMatch: `Quantity does not match in contract`,
  Sage200_INCONTRACT_UnitPrice_NotMatch: `Unit price does not match in contract`,
};
